import React, { Component } from "react";
import { Item, Label } from "semantic-ui-react";
import Linkify from "react-linkify";

// import * as LINKS from "../assets/Links";
import MemberProfile from "./MemberProfile";

class ProjectCard extends Component {
  renderTags = tags => {
    if (tags !== "") {
      const labelsList = [];
      tags.split(",").forEach(function(each, index) {
        labelsList.push(<Label key={index}>{each}</Label>);
      });
      return (
        <Item.Meta>
          <Label.Group color="grey">
            <strong>Tags:</strong> {labelsList}
          </Label.Group>
        </Item.Meta>
      );
    }
  };

  renderMemberTags = members => {
    let membersToBeRendered = [];
    Object.keys(members).forEach(function(key, index) {
      let each = members[key];
      membersToBeRendered.push(
        <MemberProfile key={each.id} data={each} type="LABEL" />
      );
    });
    return membersToBeRendered;
  };

  render() {
    let project = this.props.data;
    // console.log(project)
    return (
      <Item key={project.id}>
        <Item.Content>
          <Item.Header key={project.id}>
            {project["project_name"].toUpperCase()}
          </Item.Header>
          {this.renderTags(project.tags)}
          <Item.Description>
            <strong>Description:</strong>{" "}
            <Linkify>{project.description}</Linkify>
          </Item.Description>
          {/* <Item.Extra>Tags: {this.renderMemberTags(project.members)}</Item.Extra> */}
          <Item.Extra>
            <strong>Collaborators: </strong>
            {this.renderMemberTags(project.members)}
          </Item.Extra>
          <Item.Extra>
            <strong>Last Updated on: </strong>
              {new Date(new Date(project.modified_at).toUTCString()).toLocaleString()}
          </Item.Extra>
        </Item.Content>
      </Item>
    );
  }
}

export default ProjectCard;
